<template>
  <div class="rm-screen">
    <div v-if="loading && !users.length" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <div class="rm-stats">
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("ordered") }}</span>
          <span class="rm-stat__value rm-num">{{ sums.ordered }}</span>
        </div>
        <template v-if="canCheckTaken">
          <div class="rm-stat">
            <span class="rm-stat__label">{{ $t("taken") }}</span>
            <span class="rm-stat__value rm-num">{{ sums.taken }}</span>
          </div>
          <div class="rm-stat rm-stat--accent">
            <span class="rm-stat__label">{{ $t("difference") }}</span>
            <span class="rm-stat__value rm-num">{{ sums.difference }}</span>
          </div>
        </template>
      </div>

      <div class="rm-chip-row gm-chips" role="group" :aria-label="$t('order_status')">
        <button
          v-for="item in statusChips"
          :key="item.value"
          type="button"
          class="rm-chip"
          :class="{ 'rm-chip--active': orderStatus === item.value }"
          :aria-pressed="String(orderStatus === item.value)"
          @click="orderStatus = item.value"
        >
          {{ item.label }}
          <span class="rm-num gm-status__n">{{ item.count }}</span>
        </button>
      </div>

      <template v-if="shownRows.length">
        <ul class="rm-list rm-card">
          <li v-for="row in shownRows" :key="row.key" class="gm-user">
            <button type="button" class="gm-user__btn" @click="openWorker(row)">
              <span class="gm-user__text">
                <span class="gm-user__name">{{ row.name }}</span>
                <span class="gm-user__meta rm-num">{{ row.meta }}</span>
              </span>
              <span class="rm-status" :class="`rm-status--${statusClass(row)}`">{{ row.statusLabel }}</span>
              <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
            </button>
          </li>
        </ul>
        <button v-if="hiddenCount > 0" type="button" class="rm-text-btn gm-user__more" @click="expanded = true">
          {{ $t("report_mobile.show_more", { items: pluralT("report_mobile.workers_n", hiddenCount) }) }}
        </button>
      </template>
      <div v-else class="rm-empty">{{ emptyText }}</div>
    </template>
  </div>
</template>

<script>
import CompanyReportTabEmployee from "@/components/company/reports/tabs/CompanyReportTabEmployee.vue";
import hasPlural from "@/components/report/shared/hasPlural";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasCompanyGroupEmployeeRows from "../../hasCompanyGroupEmployeeRows";

const PAGE_SIZE = 15;

/**
 * Mobilni "Pregled korisnika" firme tipa "grupa": poručeno (i preuzeto / razlika kad firma prati preuzimanje) po
 * radniku, uz radnike koji nisu poručili. Filter statusa je red čipova sa brojem radnika; klik na radnika otvara
 * njegov mesečni pregled. Firme i period su u zaglavlju, pretraga u lupi, a radnike dobija od ljuske (kao stari
 * tab). Nasleđuje filter statusa, štampu i Excel iz starog taba.
 */
export default {
  name: "CompanyMobileGroupEmployees",
  extends: CompanyReportTabEmployee,
  mixins: [hasPlural, hasCompanyGroupEmployeeRows],
  data: () => ({
    expanded: false,
  }),
  computed: {
    shownRows() {
      const rows = this.matchedRows.map((row) => ({
        ...row,
        meta: [`ID ${row.id}`, row.company, this.isSingleDay ? row.time : "", row.externalCode].filter(Boolean).join(" · "),
      }));
      return this.expanded || this.search ? rows : rows.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.matchedRows.length - this.shownRows.length;
    },
  },
  watch: {
    orderStatus() {
      this.expanded = false;
    },
  },
  methods: {
    statusClass(row) {
      return row.state === "off" ? "idle" : row.state === "ordered" ? "all" : row.state;
    },
    openWorker(row) {
      this.$store.commit("report/SET_SELECTED_EMPLOYEE", this.toEmployeeContext(row));
      this.$emit("open-screen", "employee");
    },
  },
};
</script>
